import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  FileDownload as DownloadIcon,
  KeyboardArrowDown as ArrowDownIcon,
} from '@mui/icons-material';
import type { AuditLog } from '@byte-store-control/shared';
import { exportAuditLogsToCSV } from '../../utils/exportCsv';

interface ExportButtonProps {
  logs: AuditLog[];
  filename?: string;
  disabled?: boolean;
}

export const ExportButton: React.FC<ExportButtonProps> = ({ logs, filename, disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportCSV = () => {
    exportAuditLogsToCSV(logs, filename);
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<DownloadIcon />}
        endIcon={<ArrowDownIcon />}
        onClick={handleClick}
        disabled={disabled || logs.length === 0}
      >
        Export
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleExportCSV}>
          <ListItemIcon>
            <DownloadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Export to CSV" />
        </MenuItem>
      </Menu>
    </>
  );
};
